class UrlHelper {
    
    getApplicationUrl(appName: string, queryString?: string){
        if(queryString){
            return `/${appName}/${queryString}`;
        } else {
            return `/${appName}/`;
        }
    }
}

export const urlHelper = new UrlHelper();